var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81114 12.3345C7.63899 12.5061 7.36035 12.5061 7.18811 12.3345L3.21755 8.37518C3.04502 8.20312 3.04462 7.92377 3.21666 7.75127C3.3887 7.57868 3.66805 7.57833 3.84058 7.75038L7.49967 11.399L11.1587 7.75038C11.3313 7.57833 11.6106 7.57868 11.7826 7.75127C11.9547 7.92377 11.9543 8.20312 11.7817 8.37518L7.81114 12.3345Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49977 12.4632C7.25606 12.4632 7.05859 12.2657 7.05859 12.022V0.441176C7.05859 0.197523 7.25606 0 7.49977 0C7.74339 0 7.94095 0.197523 7.94095 0.441176V12.022C7.94095 12.2657 7.74339 12.4632 7.49977 12.4632Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.441176 10.5883C0.684829 10.5883 0.882352 10.7858 0.882352 11.0294V14.5588H14.1176V11.0294C14.1176 10.7858 14.3151 10.5883 14.5588 10.5883C14.8024 10.5883 15 10.7858 15 11.0294V15C15 15.2436 14.8024 15.4412 14.5588 15.4412H0.441176C0.197514 15.4412 0 15.2436 0 15V11.0294C0 10.7858 0.197514 10.5883 0.441176 10.5883Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.c5b63685.svg";
export { ForwardRef as ReactComponent };